import React from "react";
import { DashboardTablePrintView } from "./DashboardTable/DashboardTablePrintView";
import { useDashboardTablePrint } from "./DashboardTable/useDashboardTablePrint";
import { useDashboardTableStore } from "./DashboardTable/useDashboardTableStore";

export const DashboardTablePrintWrapper = () => {
    const { isPrintDashboardTableVisible } = useDashboardTablePrint();
    const { printData } = useDashboardTableStore();

    if (!isPrintDashboardTableVisible || !printData?.columnDefs || !printData?.groupedData) return null;

    return (
        <div className="absolute inset-0 z-50 hidden bg-white print:visible print:block">
            <DashboardTablePrintView columnDefs={printData?.columnDefs} groupedData={printData?.groupedData} />
        </div>
    );
};
